module.exports = __webpack_public_path__ + "img/send-2.c8c7611f.svg";